import { createTheme } from "@mui/material/styles";
import { esES } from '@mui/material/locale';
import LogoModiga from "../assets/img/logo-modiga.svg";
import LogoModigaNavbar from "../assets/img/logo-modiga-blanco.svg";
import logoantell from "../assets/img/logoantell.png";
import logodpm from "../assets/img/logodpm.png";
import logoeglobalt from "../assets/img/logoeglobalt.png";
import logomickey from "../assets/img/mickeylogo.png";
import logotoval from "../assets/img/logotoval.jpeg";
import logomonchis from "../assets/img/logomonchis.png";
import logoitacoty from "../assets/img/itacotylogo.jpeg";
import logocordillera from "../assets/img/cordilleralogo.png";
import slucialogo from "../assets/img/slucialogo.png";
import mediplanlogo from "../assets/img/mediplanlogo.png";
import ampaclogo from "../assets/img/ampaclogo.png";
import acisalogo from "../assets/img/acisalogo.png";
import abanlogo from "../assets/img/abanlogo.png";
import unnakilogo from "../assets/img/unnakilogo.png";
import efetelogo from "../assets/img/efetelogo.png";
import sanpatriciologo from "../assets/img/sanpatriciologo.png";
import diprocarlogo from "../assets/img/diprocarlogo.png";
import lpi_logo from "../assets/img/lpi_logo.png";
import mariam_logo from "../assets/img/mariam_logo.png";
import automotive_logo from "../assets/img/automotive_logo.png";
import inmobiliariagral_logo from "../assets/img/inmobiliariagral_logo.png";
import food_cleaning_logo from "../assets/img/food_cleaning_logo.png";
import logocraft from "../assets/img/logocraft.png";
import logoenvaco from "../assets/img/logoenvaco.png";
import logokiga from "../assets/img/logokiga.png";
import logofluoder from "../assets/img/logofluoder.png";

/* se definen los colores y las imagenes que se utilizan el sistema */
export const customTheme = createTheme({
  palette: {
    primary: {
      light: '#4d5382',
      main: '#212b55',
      dark: '#00002c',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: LogoModiga,
    imgNavbar: LogoModigaNavbar,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  },
  esES
});

export const antellTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#005A74',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logoantell,
    imgNavbar: logoantell,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const dpmTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#ff0000',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logodpm,
    imgNavbar: logodpm,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const eglobaltTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#f25826',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logoeglobalt,
    imgNavbar: logoeglobalt,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const mickeyTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#ff0000',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logomickey,
    imgNavbar: logomickey,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});


export const tovalTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#000000',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logotoval,
    imgNavbar: logotoval,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const monchisTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#e52050',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logomonchis,
    imgNavbar: logomonchis,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const itacotyTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#005A74',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logoitacoty,
    imgNavbar: logoitacoty,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const cordilleraTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#005A74',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logocordillera,
    imgNavbar: logocordillera,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const sluciaTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#483e8a',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: slucialogo,
    imgNavbar: slucialogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const mediplanTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#344f97',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: mediplanlogo,
    imgNavbar: mediplanlogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const ampacTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#07509d',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: ampaclogo,
    imgNavbar: ampaclogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const acisaTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#000067',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: acisalogo,
    imgNavbar: acisalogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const abanTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#3a434c',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: abanlogo,
    imgNavbar: abanlogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const unnakiTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#4d7b81',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: unnakilogo,
    imgNavbar: unnakilogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const efeteTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#247cdc',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: efetelogo,
    imgNavbar: efetelogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const sanpatricioTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#3d7a34',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: sanpatriciologo,
    imgNavbar: sanpatriciologo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const diprocarTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#ec1b26',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: diprocarlogo,
    imgNavbar: diprocarlogo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const pyainmobiliariaTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#221784',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: lpi_logo,
    imgNavbar: lpi_logo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const mariamTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#1f2d5f',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: mariam_logo,
    imgNavbar: mariam_logo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const automotiveTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#ec1b26',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: automotive_logo,
    imgNavbar: automotive_logo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const inmobiliariagralTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#00a0a5',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: inmobiliariagral_logo,
    imgNavbar: inmobiliariagral_logo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const foodCleaningTheme = createTheme({
  palette: {
    primary: {
      light: '#009EBE',
      main: '#0c3e89',
      dark: '#009EBF',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: food_cleaning_logo,
    imgNavbar: food_cleaning_logo,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const craftTheme = createTheme({
  palette: {
    primary: {
      light: '#e74c3c',
      main: '#c0392b',
      dark: '#922b21',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logocraft,
    imgNavbar: logocraft,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const envacoTheme = createTheme({
  palette: {
    primary: {
      light: '#4caf50',
      main: '#2e7d32',
      dark: '#1b5e20',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logoenvaco,
    imgNavbar: logoenvaco,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const kigaTheme = createTheme({
  palette: {
    primary: {
      light: '#4d5382',
      main: '#212b55',
      dark: '#00002c',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logokiga,
    imgNavbar: logokiga,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#00002c',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});

export const fluoderTheme = createTheme({
  palette: {
    primary: {
      light: '#5a6f9a',
      main: '#384f79',
      dark: '#263654',
      contrastText: '#fff',
      error: '#d85454'
    },
    secondary: {main: '#fd9710', contrastText: '#fff',}
  },
  
  status: {
    imgLogin: logofluoder,
    imgNavbar: logofluoder,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: "Poppins, sans-serif"
        },
        a: {
          "&:hover": {
            color: '#263654',
          },
        }
      }
    }
  },
  typography: {
    fontFamily: [
      "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    title: {
      fontStyle: 'Poppins',
      fontSize: '1.7rem',
      
      color: '#6d6d6d',
    },
    poster: {
      color: 'red',
    }
  }
});


